var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { limitInputToPositiveValue } from "../../utils";
import InputField from "../InputField";
const PositiveNumberInput = (_a) => {
    var { name, onNumberChange, error, customErrorText, disabled, value = '', autoComplete = 'value' } = _a, rest = __rest(_a, ["name", "onNumberChange", "error", "customErrorText", "disabled", "value", "autoComplete"]);
    return (_jsx(InputField, Object.assign({}, rest, { name: name, value: value.toString(), type: "number", autoComplete: autoComplete, onChange: ({ currentTarget }) => onNumberChange(limitInputToPositiveValue(currentTarget), name), onBlur: ({ currentTarget }) => onNumberChange(Number(currentTarget.value), name) }), void 0));
};
export default PositiveNumberInput;
